import {
  EntityObject,
  EntityObjectAddress,
  EntityObjectResponse,
  EntityObjectResponseAddress,
  GeoAutocompletionResponse,
} from '../../../@types/geoAutocompletion-types'

export const suggestionsToApp = (a: GeoAutocompletionResponse[] | undefined): EntityObject[] =>
  a ? a.map((entity: GeoAutocompletionResponse) => gacEntityToApp(entity.entity)) : []

export const gacEntityToApp = ({ id, label, address }: EntityObjectResponse): EntityObject => ({
  id: id ?? '0',
  label,
  address: address && addressToApp(address),
})

export const addressToApp = ({
  city,
  postcode,
  quarter,
  street,
}: EntityObjectResponseAddress): EntityObjectAddress => ({
  city,
  postcode,
  quarter,
  street,
})
